import { render } from "./AppManager.vue?vue&type=template&id=54d9a17a"
import script from "./AppManager.vue?vue&type=script&lang=js"
export * from "./AppManager.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__